import React from "react";
import FullScreenSection from "./FullScreenSection";
import {
  Text,
  HStack,
  Heading,
  VStack,
  Box,
  Link,
  useMediaQuery,
} from "@chakra-ui/react";
import Tag from "./Tag";

const Footer = () => {
  const [isMobile] = useMediaQuery("(max-width: 640px)");
  const [isTablet] = useMediaQuery("(max-width: 991px)");

  return (
    <FullScreenSection
      alignContent="flex-start"
      justifyContent="center"
      alignItems="flex-start"
      width="100%"
      flexDirection="column"
      backgroundColor="#0F4C5C"
      isDarkBackground
      minHeight="20vh"
      py={{ base: "32px" }}
      px={{ base: "32px" }}
    >
      <Box width="100%">
        <VStack
          alignItems="flex-start"
          spacing={{ base: "30px", md: "50px", lg: "65px" }}
          width="100%"
        >
          {/* Header Section */}
          <Box>
            <Text fontSize="24px" fontWeight="400" lineHeight="36px" mb="20px">
              Contact me
            </Text>
            <Heading
              fontSize={{ base: "30px", md: "40px" }}
              fontWeight="700"
              lineHeight={{ base: "42px", md: "56px" }}
              color="#F5F5F5"
            >
              Have a project in mind?
              <br />
              Let's make it happen
            </Heading>
          </Box>

          {/* Contact Information */}
          <Box
            fontSize={{ base: "18px", md: "20px" }}
            fontWeight="400"
            lineHeight={{ base: "28px", md: "30px" }}
          >
            <Text>Cape Town, South Africa</Text>
            <Link
              href="mailto:xola.dossantos@xdode.com"
              textDecoration="underline"
              _hover={{ textDecoration: "underline" }}
            >
              xola.dossantos@xdode.com
            </Link>
          </Box>

          {/* Footer Links */}
          <Box
            display="flex"
            flexDirection={{ base: "column", md: "column", lg: "row" }}
            justifyContent="space-between"
            width="100%"
          >
            {/* Terms Section */}
            {/* <Box
              fontSize={{ base: "18px", md: "20px" }}
              fontWeight="400"
              lineHeight={{ base: "28px", md: "30px" }}
              mb={{ base: "15px", md: "20px", lg: 0 }}
              mr={{ lg: "40px" }}
            >
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Terms of service
              </Link>
              <br />
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Privacy policy
              </Link>
              <br />
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Impressum
              </Link>
            </Box> */}

            {/* Social Media - First Column */}
            {/* <Box
              fontSize={{ base: "18px", md: "20px" }}
              fontWeight="400"
              lineHeight={{ base: "28px", md: "30px" }}
              mb={{ base: "15px", md: "20px", lg: 0 }}
              mr={{ lg: "40px" }}
            >
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Facebook
              </Link>
              <br />
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Instagram
              </Link>
              <br />
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Twitter
              </Link>
            </Box> */}

            {/* Social Media - Second Column */}
            {/* <Box
              fontSize={{ base: "18px", md: "20px" }}
              fontWeight="400"
              lineHeight={{ base: "28px", md: "30px" }}
              mb={{ base: "15px", md: "20px", lg: 0 }}
              mr={{ lg: "40px" }}
            >
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Github
              </Link>
              <br />
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Linkedin
              </Link>
              <br />
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Teams
              </Link>
            </Box> */}

            {/* Social Media - Third Column */}
            {/* <Box
              fontSize={{ base: "18px", md: "20px" }}
              fontWeight="400"
              lineHeight={{ base: "28px", md: "30px" }}
              mb={{ base: "15px", md: "20px", lg: 0 }}
              mr={{ lg: "40px" }}
            >
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Youtube
              </Link>
              <br />
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Behance
              </Link>
              <br />
              <Link href="#" _hover={{ textDecoration: "underline" }}>
                Dribbble
              </Link>
            </Box> */}

            {/* Jobs and Copyright */}
            <Box
              fontSize={{ base: "18px", md: "20px" }}
              fontWeight="400"
              lineHeight={{ base: "28px", md: "30px" }}
            >
              {/* <Link
                href="/downloads/Xola_dos_Santos_Brief_Re_sume_.pdf"
                _hover={{ textDecoration: "underline" }}
              >
                Download Resumé PDF
              </Link> */}
              <br />
              <Text>©2025 Xola dos Santos</Text>
            </Box>
          </Box>
        </VStack>
      </Box>
    </FullScreenSection>
  );
};

export default Footer;
